import React, { FC, useState } from 'react';
import bytes from 'bytes';

import { Stack } from '../Stack';
import { Download24, File24 } from '../../icons';
import { Avatar } from '../Avatar';
import { Typography } from '../Typography';
import { IconButton } from '../IconButton';
import { AvatarProps } from '../Avatar/types';


export interface DownloadFileProps {
    name: string;
    size: number;
    ext?: string;
    invactive?: boolean;
    withDownloadButton?: boolean;
    onDownload?: () => void;
}

export const DownloadFile: FC<DownloadFileProps> = ({
    name, ext, size, invactive, withDownloadButton, onDownload,
}) => {
    const [hovered, setHovered] = useState(false);

    const avatarBgColor = hovered && !invactive
        ? 'general.primary50'
        : 'grayscale.shade10';

    const avatarIcon = hovered && !invactive
        ? <Download24 />
        : <File24 />;

    let avatarColor = 'infoCustom.green50';
    if (invactive)
        avatarColor = 'grayscale.shade85';
    else if (hovered)
        avatarColor = 'grayscale.shade0';

    return (
        <Stack
            data-testid='document-container'
            direction='row'
            spacing={4}
            alignItems='center'
            maxWidth='624px'
            onClick={onDownload}
            title={name}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            sx={{
                cursor: onDownload ? 'pointer' : 'default',
            }}
        >
            <Avatar
                size='M'
                bgColor={avatarBgColor as AvatarProps['bgColor']}
                color={avatarColor}
            >
                {avatarIcon}
            </Avatar>
            <Stack spacing={1} flexGrow={1} overflow='hidden'>
                <Typography
                    data-testid={`document-${name}`}
                    variant='regularBody2'
                    color='grayscale.shade100'
                    noWrap
                >
                    {name}
                </Typography>
                <Typography variant='regularCaption1' color='grayscale.shade85'>
                    {`${ext ? `${ext.toUpperCase()}・` : ''}${bytes(size, { unitSeparator: ' ' })}`}
                </Typography>
            </Stack>
            {withDownloadButton && (
                <IconButton variant='stroke' size='small'>
                    <Download24 />
                </IconButton>
            )}
        </Stack>
    );
};
